export const VERSION = "1.2.1";


//////////////////
// WEBPACK FOOTER
// ./node_modules/axios/lib/env/data.js
// module id = null
// module chunks = 